import React from 'react';
import cls from 'classnames';
import { SwapStatus } from '../../../types/enums';
import { ReactComponent as Proposed } from '../../../assets/svg/swapFlow/proposed.svg';
import { ReactComponent as Initiated } from '../../../assets/svg/swapFlow/initiated.svg';
import { ReactComponent as Executed } from '../../../assets/svg/swapFlow/executed.svg';
import { ReactComponent as Rejected } from '../../../assets/svg/swapFlow/rejected.svg';

interface ISwapStepSvg {
  status: SwapStatus;
  isUserProposer?: boolean;
}

export const SwapStepSvg: React.FC<ISwapStepSvg> = ({ status, isUserProposer }) => {
  switch (status) {
    case SwapStatus.PROPOSED:
      return (
        <Proposed
          className={cls('fill-current', {
            'text-blueberry-400': isUserProposer,
            'text-lemon-400': !isUserProposer,
          })}
        />
      );
      break;
    case SwapStatus.INITIATED:
      return (
        <Initiated
          className={cls('fill-current', {
            'text-blueberry-400': isUserProposer,
            'text-lemon-400': !isUserProposer,
          })}
        />
      );
      break;
    case SwapStatus.EXECUTED:
      return <Executed />;
      break;
    case SwapStatus.CANCELLED:
      return <Rejected />;
      break;
    case SwapStatus.REJECTED:
      return <Rejected />;
      break;
    default:
      return null;
      break;
  }
};
